var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeRole(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.879 20.188L1.5 14.81C1.21849 14.5287 1.06032 14.147 1.06032 13.749C1.06032 13.351 1.21849 12.9693 1.5 12.688L12 2.18799C12.2814 1.90673 12.6631 1.74881 13.061 1.74899H18.439C19.2674 1.74899 19.939 2.42057 19.939 3.24899V8.62799C19.9389 9.02554 19.781 9.40679 19.5 9.68799",
    stroke: "#758ABD",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.189 5.12399C15.9819 5.12399 15.814 5.29189 15.814 5.49899C15.814 5.7061 15.9819 5.87399 16.189 5.87399C16.3961 5.87399 16.564 5.7061 16.564 5.49899C16.564 5.29189 16.3961 5.12399 16.189 5.12399V5.12399",
    stroke: "#758ABD",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.689 19.749H10.939V23.499",
    stroke: "#758ABD",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.357 20.482C21.5403 22.8686 19.2223 24.4088 16.7057 24.2371C14.1891 24.0653 12.1018 22.2244 11.617 19.749",
    stroke: "#758ABD",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.189 16.749H22.939V12.999",
    stroke: "#758ABD",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.522 16.015C12.3401 13.6299 14.6578 12.0912 17.1735 12.2632C19.6892 12.4351 21.776 14.2747 22.262 16.749",
    stroke: "#758ABD",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeRole);
export default __webpack_public_path__ + "static/media/change-role.59c91001.svg";
export { ForwardRef as ReactComponent };